import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import Layout from "../components/layout";
// import ArticlesComponent from "../components/articles";
import "../assets/css/main.css";
import { Link } from "gatsby";
import YunJia from "../components/yunJia"
import LianXi from "../components/lianXi"

const IndexPage = () => {
  const data = useStaticQuery(query);
  const news = data.topTenNews.edges
  // console.log(news)
  return (
    <Layout seo={data.strapiHomepage.seo}>
    <table width="970" border="0" cellSpacing="0" cellPadding="0" align="center" bgcolor="#FFFFFF">
    <tbody><tr>
      <td width="265" valign="top">
      <table width="263" border="0" cellSpacing="0" cellPadding="0" align="center">
        <tbody><tr>
          <td>&nbsp;</td>
        </tr>
              <tr>
          <td width="263" height="38" background="/images/left_bj1.gif" style={{ paddingLeft: '25px' }}>&nbsp;<span className="STYLE3">航空货运行业新闻</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a href="#">&gt;&gt;More</a></td>
    </tr>
        <tr>
          <td><table width="100%" border="0" cellSpacing="0" cellPadding="0">
            <tbody><tr>
              <td width="1" bgcolor="#e5e5e9"></td>
              <td width="261">
            <table width="95%" border="0" cellPadding="0" cellSpacing="0" align="center">
    
    <tbody>
    {news.map(post => {
      {/* console.log(post.node.strapiId) */}
          return (
    <tr key={post.node.strapiId}>
    <td height="25" align="left" width="78%"><img src="/images/jt.gif" width="3" height="5" />&nbsp;<Link to={`/article/${post.node.slug}`} className="uk-link-reset">{post.node.title}</Link></td>
    </tr>
          )
        })}
    </tbody>
    </table>
    </td>
    <td width="1"></td>
    </tr>
    </tbody></table></td>
        </tr>
        <tr>
          <td width="263" height="1" bgcolor="#e5e5e9"></td>
        </tr>
              <tr>
          <td>&nbsp;</td>
        </tr>
      </tbody>
      </table>
      {/* 运价 */}
      <YunJia />
       {/* end运价 */}
      <table style={{marginTop: '10px'}} cellSpacing="0" cellPadding="0" width="214" border="0" align="center" background="/images/6.gif" height="200">
                <tbody>
                <tr>
                  <td height="20"></td>
                </tr>
                <tr>
                  <td>
                    <table cellSpacing="0" cellPadding="8" width="210" align="center" border="0">
                      <tbody>
                      <tr><td align="left"><LianXi /></td></tr> 
                      </tbody>
                          </table>
                          </td>
                          </tr>
                          </tbody>
                          </table>
    </td>
      {/* 右栏 */}
      <td valign="top">
      <table width="95%" border="0" cellSpacing="0" cellPadding="0" align="center">
      <tbody><tr>
        <td>&nbsp;</td>
      </tr>
      <tr>
        <td width="669" height="37" background="/images/index_bj1.gif" style={{paddingLeft:'25px'}}>&nbsp;<span className="STYLE3">公司简介</span></td>
      </tr>
      <tr>
        <td><table width="100%" border="0" cellSpacing="0" cellPadding="0">
  <tbody><tr>
            <td width="1" bgcolor="#e5e5e9"></td>
    <td width="667"><table width="95%" border="0" cellSpacing="0" cellPadding="0" align="center">
  <tbody><tr>
    <td><div style={{textAlign:'justify',textJustify:'inter-ideograph',LineHeight: '25px',fontSize: '13px', marginTop: '5px'}}>　　<a href="http://www.dongdahuoyun.com">上海东大货运</a>有限公司是一家专业从事<a href="http://www.dongdahuoyun.com">航空货运</a>代理，国内国际<a href="http://www.dongdahuoyun.com">航空运输</a>物流为一体的<a href="http://www.dongdahuoyun.com">上海空运</a>公司，公司自成立十多年以来，本着以客户至上、以信誉求生存、以服务求保障为原则。公司以上海为中心辐射全国和全球一百多个大中城市。提供24小时门到门的航空货运服务。我公司与山东航空、厦门航空、国际航空、四川航空、南方航空、上海航空等各至公司有着良好的合作关系，提发货物利便快捷，公司主营精品服务：<strong>上海航空货运</strong>，上海航空快递，<strong>上海空运</strong>至国内大中城市，限时8小时到港自提，12至24小时门到门服务。<br />
      <br />
      　　本公司专业代办理国际快递 EMS ， DHL ， TNT ， UPS ， FEDEX 的品牌航空速递业务！服务地区遍布欧美亚非个大洲的大中城市。 本公司的业务范围涵盖：航空货运、航空快递、空陆联运。核心业务包括：国内国际包机空运,国际速递、国内国际空运、第三方物流等航空货运、航空快递运输、仓储、包装、配送、装卸、国际快递等为一体。公司自成立以来不断提高销售团队的服务意识,确保您的货物能安全,快捷,及时到达目的地.而且陆续在全国各大一线城市建立了笼盖全国的专业化空运配送网络，为客户提供派送上门、运费到付、代收货款、货物回程、异地调货及转送二、三级城市等专业服务，免除客户后顾之忧,同时承诺,货物运输,快递,仓储,异地派送全过程网上跟踪,让客户在市场经济方面立足领先地位,从而为客户事业提供可靠的保障,让服务在没有间隔感的情况下无穷延伸。并且，我公司开辟了到欧美、台湾、日本、韩国、新加坡、马来西亚、中东、南非的特色专线的门到门服务。 
<br />
<br />
　　同时还提供特殊物品空运服务包括：活体动植物、麻醉药品、音像制品、罐装液体、粉状物品、海鲜和违禁品----爆炸品(如炸药)、压缩气体和液压气体(如煤气)、易燃易爆液体或固体、氧化剂和有机过氧化物(乒乓球)、毒品和感染性物品(如白粉)、放射性物品、腐蚀品(如硫酸)、磁性物品、麻醉物品、电池等物品。 
<br />
<br />
　　公司实现以客户为中心以服务为根本，严格履行合同业务，维护客户合法权益，以换得广大客户依赖和支持。<br /><br />
<img src="/images/yyzz.jpg" /></div></td>
  </tr>
</tbody></table>
</td>
            <td width="1" bgcolor="#e5e5e9"></td>
  </tr>
</tbody></table>
</td>
      </tr>
            <tr>
        <td width="669" height="1" bgcolor="#e5e5e9"></td>
      </tr>
    </tbody>
    </table>     
      </td>
      {/* end 右栏 */}
    </tr>
    </tbody></table>
    </Layout>
  );
};

const query = graphql`
  query {
    strapiHomepage {
      hero {
        title
      }
      seo {
        metaTitle
        metaDescription
        shareImage {
          publicURL
        }
      }
    }
    topTenNews: allStrapiArticle(limit: 10, filter: {category: {slug: {eq: "news"}}, status: {eq: "published"}}) {
      edges {
        node {
          title
          slug
          strapiId
          publishedAt
        }
      }
    }
    allStrapiArticle(filter: { status: { eq: "published" } }) {
      edges {
        node {
          strapiId
          slug
          title
          category {
            name
          }
          image {
            childImageSharp {
              fixed(width: 800, height: 500) {
                src
                ...GatsbyImageSharpFixed
              }
            }
          }
          author {
            name
            picture {
              childImageSharp {
                fixed(width: 30, height: 30) {
                  src
                  ...GatsbyImageSharpFixed
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default IndexPage;
